var res = [{"key":"10/11","value":"73.2"},{"key":"11/12","value":"42.8"},{"key":"12/13","value":"47.0"},{"key":"13/14","value":"53.1"},{"key":"14/15","value":"35.0"},{"key":"15/16","value":"36.4"},{"key":"16/17","value":"35.1"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/minutes-south-east.csv
// module id = 624
// module chunks = 0